class TermsModal extends ModalDialog {
    constructor() {
        super();
        this.querySelector('[id^="ModalConfirm-"]').addEventListener('click', this.confirm.bind(this, false));
    }

    confirm() {
        const produceTerms = this.querySelector('#product-produce-terms');
        const alcoholTerms = this.querySelector('#product-alcohol-terms');

        if ((!produceTerms || produceTerms?.checked) && (!alcoholTerms || alcoholTerms?.checked)) {
            this.hide();
        }
    }

    // connectedCallback() {
    //   if (this.moved) return;
    //   this.moved = true;
    //   document.body.appendChild(this);
    // }

    // show(opener) {
    //   this.openedBy = opener;
    //   const popup = this.querySelector('.template-popup');
    //   document.body.classList.add('overflow-hidden');
    //   this.setAttribute('open', '');
    //   if (popup) popup.loadContent();
    //   trapFocus(this, this.querySelector('[role="dialog"]'));
    //   window.pauseAllMedia();
    // }

    // hide() {
    //   document.body.classList.remove('overflow-hidden');
    //   document.body.dispatchEvent(new CustomEvent('modalClosed'));
    //   this.removeAttribute('open');
    //   removeTrapFocus(this.openedBy);
    //   window.pauseAllMedia();
    // }
}

customElements.define('terms-modal', TermsModal);
